import { useMemo } from "react";
import { useTheme } from "../../../../../../Themes/themeContext";

export const useCategoryResourceAllocationBackground = (size = 20) => {
	const theme = useTheme();
	return useMemo(() => {
		const kpiCategory = theme.semanticColors.kpiCategory;

		return `linear-gradient(45deg, ${kpiCategory} ${size}px, ${kpiCategory} ${size}px, transparent ${size}px)`;
	}, [size, theme.semanticColors.kpiCategory]);
};
